import ApiModule from './index'
import { _ } from '@iskytrip/sdk'
import BaseModel from '../../base/BaseModel'
import { FLIGHT_STATE } from '../../vendor/constant'
import { env } from '../../env.config'

/**
 * @description 航班是否过期
 * @summary 判断逻辑：
 *      1. 当航班状态为未取消，且航班实际到达日期已为历史日期时，过期；
 *      2. 当航班状态为取消，且航班计划起飞日期已为历史日期时，过期；
 *      tip: 判断日期，不是时间
 * @param {int} flightStateCode - 状态枚举值 参考constant.FLIGHT_STATE
 * @param {object} flightDate = {} - 航班时间
 * @param {timestamp} [flightDate.flightDeptimePlanDate] - 航班计划起飞时间
 * @param {timestamp} [flightDate.flightArrtimeDate] - 航班实际到达时间
 * @return {boolean}
 */
const isFlightExpire = (flightStateCode, { flightDeptimePlanDate, flightArrtimeDate }) => {
	const toDay = _.format(new Date(), 'yyyy-MM-dd')
	const toDayTimestamp = +new Date(toDay)

	try {
		if (
			flightStateCode === FLIGHT_STATE.CANCEL.code ||
			flightStateCode === FLIGHT_STATE.ADVANCE_CANCEL.code
		) {
			//航班取消
			const deptimePlanDateTimestamp = +new Date(
				_.format(flightDeptimePlanDate, 'yyyy-MM-dd'),
			)
			if (toDayTimestamp > deptimePlanDateTimestamp) {
				return true
			}
		} else {
			//航班非取消
			if (_.isEmpty(flightArrtimeDate)) {
				return false
			}

			const arrtimeDateTimestamp = +new Date(_.format(flightArrtimeDate, 'yyyy-MM-dd'))
			if (toDayTimestamp > arrtimeDateTimestamp) {
				return true
			}
		}
		return false
	} catch (error) {
		console.error(error)
		return false
	}
}

export class QueryUserTravelList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.PRODUCTFLIGHT
		this.url = '/flight-follow/queryUserTravelList'
		this.desc = '查询用户行程列表'
		this.timeout = env === 'prod' ? 10000 : 60000
	}
}

export class GetFlights extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.PRODUCTFLIGHT
		this.url = '/flight-follow/getFlights'
		this.desc = '查询航班信息列表'
	}

	dataformat(data) {
		super.dataformat(data)

		const resultCode = +data.resultCode

		let array = []
		if (_.isArray(data.resultData)) {
			array = data.resultData
		}

		const resultData = array.map((cur) => ({
			...cur,
			airline: {
				logo: cur.ailineIcon || '',
				flightNo: cur.flightNo || '',
				flightCompany: cur.flightCompany || '',
			},
			flightDep: {
				city: cur.flightDep || '', //出发城市
				flightHTerminal: cur.flightHTerminal || '',
				airportCode: cur.flightDepCode || '', //出发机场code
				airport: cur.flightDepAirport || '',
				terminal: cur.flightHTerminal, //出发航站楼
				actualTimeDate: cur.flightDeptimeDate, //实际出发时间
				timePlanDate: cur.flightDeptimePlanDate, //计划出发时间
				timeReadyDate: cur.flightDeptimeReadyDate, //预计出发时间
			},
			flightArr: {
				city: cur.flightArr || '', //到达城市
				flightTerminal: cur.flightTerminal || '',
				airportCode: cur.flightArrCode || '', //到达机场code
				terminal: cur.flightTerminal, //到达航站楼
				airport: cur.flightArrAirport || '',
				actualTimeDate: cur.flightArrtimeDate, //实际到达时间
				timePlanDate: cur.flightArrtimePlanDate, //计划到达时间
				timeReadyDate: cur.flightArrtimeReadyDate, //预计到达时间
			},
			// 航班状态
			flightState: {
				key: +cur.flightStateCode,
				value: cur.flightState,
			},
			isExpire: isFlightExpire(+cur.flightStateCode, {
				flightArrtimeDate: cur.flightArrtimeDate,
				flightDeptimePlanDate: cur.flightDeptimePlanDate,
			}),
		}))

		return {
			resultCode,
			resultData: resultData || [],
		}
	}
}

export class GetFlightDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.PRODUCTFLIGHT
		this.url = '/flight-follow/getFlightDetail'
		this.desc = '获取行程详情'
	}

	dataformat(data) {
		super.dataformat(data)

		const {
			ailineIcon = '',
			flightNo = '',
			airlineShortName = '',
			flightDep = '',
			flightDepAirport = '',
			flightDepCode = '',
			flightHTerminal = '',
			flightDeptimeDate = null,
			flightDeptimePlanDate = null,
			flightDeptimeReadyDate = null,
			flightArr = '',
			flightArrAirport = '',
			flightArrCode = '',
			flightTerminal = '',
			flightArrtimeDate = null,
			flightArrtimePlanDate = null,
			flightArrtimeReadyDate = null,
			flightState = '',
			flightStateCode = 1,
			airportStatus = '',
			airportStatusCode = 1,
			stopAirportCode,
			stopAirportName,
			stopCityName,
			...rest
		} = data.resultData || {}

		return {
			...rest,
			airline: {
				logo: ailineIcon || '',
				flightNo: flightNo || '',
				flightCompany: airlineShortName || '',
			},
			flightDep: {
				city: flightDep, //出发城市
				airportCode: flightDepCode, //出发机场code
				airport: flightDepAirport, //出发机场
				terminal: flightHTerminal, //出发航站楼
				actualTimeDate: flightDeptimeDate, //实际出发时间
				timePlanDate: flightDeptimePlanDate, //计划出发时间
				timeReadyDate: flightDeptimeReadyDate, //预计出发时间
			},
			flightArr: {
				city: flightArr, //到达城市
				airportCode: flightArrCode, //到达机场code
				airport: flightArrAirport, //到达机场
				terminal: flightTerminal, //到达航站楼
				actualTimeDate: flightArrtimeDate, //实际到达时间
				timePlanDate: flightArrtimePlanDate, //计划到达时间
				timeReadyDate: flightArrtimeReadyDate, //预计到达时间
			},
			// 航班状态
			flightState: {
				key: +flightStateCode,
				value: flightState,
			},
			// 机场情况
			airportStatus: {
				key: airportStatusCode,
				value: airportStatus,
			},
			// 经停情况
			transfer: {
				city: stopCityName,
				airportName: stopAirportName,
				airportCode: stopAirportCode,
			},
			isExpire: isFlightExpire(+flightStateCode, {
				flightArrtimeDate: flightArrtimeDate,
				flightDeptimePlanDate: flightDeptimePlanDate,
			}),
		}
	}
}

export class DeleteFlight extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.PRODUCTFLIGHT
		this.url = '/flight-follow/deleteFlight'
		this.desc = '删除行程'
	}
}

export class FollowFlight extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.PRODUCTFLIGHT
		this.url = '/flight-follow/followFlight'
		this.desc = '添加航班信息'
		this.setParams({
			travelType: 1,
		})
	}
}

export class QueryFlightListByAirport extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.PRODUCTFLIGHT
		this.url = '/flight-follow/queryFlightListByAirport'
		this.desc = '机场大屏'
	}
}

export class GetAirportTraffic extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.PRODUCTFLIGHT
		this.url = '/flight-follow/getAirportTraffic'
		this.desc = '航班信息'
	}
}

export class GetFlightSuggestTime extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.PRODUCTFLIGHT
		this.url = '/flight-follow/getFlightSuggestTime'
		this.desc = '查询航班信息列表'
	}

	dataformat(json) {
		// delete json['ResponseStatus'];
		// delete json['resstatus'];
		// if (+json.resultCode) {
		//     Bridge.appToast(json.errMsg, 1)
		// }
		return json
	}
}
